<template>
    <div class="quetaHome">
        <div class="list">
            <div>类型</div>
            <span v-for="(item,index) in projectDict.bg_project_category" :key="index" :class="{ active :cateinx == index }" @click="getCate(item,index)">{{ item.dict_label }}</span>
        </div>
       <div class="list">
            <div>类别</div>
            <span :class="{ active : lbinx == 100 }" @click="setlbList(1,100)">全部</span>
            <span v-for="(item,index) in projectCategoryList" :key="index" :class="{ active :lbinx == index }" @click="setlbList(item,index)">{{ item.dict_label }}</span>
        </div>
        <!-- <div class="list">
            <div>性质</div>
            <span :class="{ active : natinx == 10 }" @click="getNature(1,10)">全部</span>
            <span v-for="(item,index) in projectDict.bg_project_nature" :key="index" :class="{ active :natinx == index }" @click="getNature(item,index)">{{ item.dict_label }}</span>
        </div> -->
        <div class="list">
                <div>价格</div>
                <span :class="{ active : priceinx == 10 }" @click="priceCate(1,10)">全部</span>
                <span v-for="(item,index) in projectDict.bg_quotation_price" :key="index" :class="{ active :priceinx == index }"  @click="priceCate(item,index)">{{ item.dict_label }}</span>
                
        </div>
        <!-- <a-spin :spinning="spinning">
        <div class="list">
                <div style="line-height:30px;">地区</div>
                <div class="area">
                    <span :class="{ active : areainx == 100 }" @click="getarealist(1,100)">全部</span>
                    <span v-for="(item,index) in areaList" :key="index" :class="{ active :areainx == index }"  @click="getarealist(item,index)">{{ item.name }}</span>
                </div>
        </div>
        <div class="list" v-if="childremList.length>0">
                <div style="line-height:30px;">街道</div>
                <div class="area">
                    <span :class="{ active : childinx == 100 }" @click="getChildlist(1,100)">全部</span>
                    <span v-for="(item,index) in childremList" :key="index" :class="{ active :childinx == index }"  @click="getChildlist(item,index)">{{ item.name }}</span>
                </div>
        </div>
         </a-spin>  -->
        <div class="queta-list" v-loading="loadingDiv"  style="min-height:330px;">
            <div class="main-detail" v-for="(item,index) in dataList" :key="index">
                <div class="mainImg" @click="$router.push({ path:'/quetaDetail',query:{ id:item.id } })">
                    <img :src="item.pictureUrl[0]">
                </div>
                <div class="intro">
                    <div>
                        <div v-if="projectDict">
                            <span>{{ item.projectCategoryName }}</span>
                            <!-- <span>{{ $utils.getVal(projectDict.bg_project_nature,item.projectNature) }}</span> -->
                        </div>
                        <div>
                            <a-tooltip placement="topLeft">
                                <template slot="title">
                                  <span class="address">{{ item.cityName + item.countyName + item.townName + item.villageName }}</span>
                                </template>
                                <span class="address">{{ item.cityName + item.countyName + item.townName + item.villageName }}</span>
                            </a-tooltip>
                            <span>{{ item.quotationPrice }}万元</span>
                        </div>
                    </div>
                    <div><a-button type="primary" @click="setOrder(item)">摘单</a-button></div>
                </div>
            </div> 
            <div v-if="dataList.length==0" style="width:100%;height:330px;display:flex;justify-content: center;align-items: center;">
                  未查询到相关数据
            </div>       
        </div>   
        <pagination ref="pagination" :current="params.pageNum" :total="total" @getList="getList"></pagination>
        <a-modal title="确认下单？" :visible="visible" :confirmLoading="loading"  cancelText="取消" okText="确定"  @ok="handleOk" @cancel="handleCancel">
            <p>总额： {{ currentItem.quotationPrice }}万元 </p>
            <p>流转保证金：{{ currentItem.margin }}万元</p>
            <p>温馨提示: 生成订单后30分钟内可主动撤单</p>
            <p>请确认是否需要开票:</p>
            <a-radio-group v-model="query.invoiceStatus">
                <a-radio value="0">
                    开票
                </a-radio>
                <a-radio value="1">
                    不开票
                </a-radio>
            </a-radio-group>
        </a-modal>
    </div>   
   
</template>

<script>
export default {
    data(){
        return{
            projectDict:'',
            cateinx:10,
            natinx:10,
            priceinx:10,
            areainx:100,
            childinx:100,
            childremList:[],
            lbinx:100,
            loadingDiv:false,
            params:{
                projectType:'01',
                projectCategory:'',//类别
                projectNature:'',//性质
                quotationPrice:'',//价格
                cityCode:'',//地区
                countyCode:'',
                pageSize:10,
                pageNum:1
            },
            dataList:[],
            areaList:[],
            spinning:false,
            total:0,
            visible:false,
            currentItem:'',
            value:'',
            query:{
                invoiceStatus:'1',
                margin:'',
                quotationId:'',
            },
            loading:false,
             projectCategoryList:[]
        }
    },
    created(){
        //获取字典
        this.$https.get('/portal/projectDict/list').then(res=>{
                if(res.code == 200){
                    this.projectDict = res.rows[0];
                    if(this.$route.query.index){
                        this.getCate(this.projectDict.bg_project_category[1],1)
                    }else{
                        this.getCate(this.projectDict.bg_project_category[0],0)
                    }
                    
                }else{
                     this.$message.info(res.msg)
                }
        })
        this.getArea();
        // if(this.$route.query.index){
        //     this.cateinx = this.$route.query.index;
        //     this.getDataList();
        // }else{
        //     this.getDataList();
        // }
    },
    mounted(){
        this.$parent.current = '2';
    },
    methods:{
        getCate(item,index){
            this.cateinx = index;
            this.lbinx = 100;
            this.params.projectType = item.dict_value;
            this.getDataList();
            this.$https.get(`/portal/projectDict/getListByProjectType/${item.dict_value}`).then(res=>{
                 if(res.code == 200){
                     this.projectCategoryList = res.rows
                 }
            })
        },
        setlbList(item,index){
            this.params.projectCategory = item==1?'':item.dict_value;
            this.lbinx = index;
            this.getDataList();
        },
        getNature(item,index){
            this.natinx = index;
            this.params.projectNature = item.dict_value;
            this.getDataList();
        },
        priceCate(item,index){
            this.priceinx = index;
            this.params.quotationPrice = item==1?'':item.dict_value;
            this.getDataList();
        },
        getarealist(item,index){
             this.areainx = index;
            if(item == 1){
                this.params.cityCode = '';
                this.childremList = [];
                this.getDataList();
            }else{
                this.params.cityCode = item.code;
                this.childremList = item.childremList;
                this.getDataList();
            }
           
           
        },
        getChildlist(item,index){
            this.childinx = index;
            this.params.countyCode = item.code;
            this.getDataList();
        },
        getList(page){
            this.params.pageNum = page;
            this.getDataList();
        },
        getArea(){
            this.spinning = true;
            this.$https.get('/portal/projectDict/dictAreaList').then(res=>{
                this.spinning = false;
                if(res.code == 200){
                    this.areaList = res.rows;
                }
            }).catch(()=>{
                this.spinning = false;
            })
        },
        getDataList(){
            this.loadingDiv = true;
            this.$https.get('/portal/listing/projectQuotationListForBuyers',{params:this.params}).then(res=>{
                this.loadingDiv = false;
                if(res.code == 200){
                    res.rows.forEach(item=>{
                        item.pictureUrl = item.pictureUrl.split(',');
                    })
                    this.dataList = res.rows
                    this.total = Number(res.total);
                }
            }).catch(error=>{
                    this.$message.error(res.msg);
                    this.loadingDiv = false;
            })
        },
        handleOk(){
            if(!this.query.invoiceStatus){
               this.$message.info('请选择是否需要开票');
               return false
            }
            this.loading = true;
            this.$https.post('/portal/listing/pickUp',this.query).then(res=>{
                this.loading =false;
                if(res.code == 200){
                    this.$message.success('下单成功');
                    this.params.pageNum = 1;
                    this.getDataList();
                    this.visible = false;
                }else{
                    this.$message.error(res.msg)
                }
            }).catch(error=>{
                this.loading = false;
            })
        },
        handleCancel(){
            this.visible = false;
        },
        setOrder(item){
            this.currentItem = item;
            this.query.margin = item.margin;
            this.query.quotationId = item.id;
            this.visible = true;
        }
    }
}
</script>

<style lang="less" scoped>
.quetaHome{
    width: 1300px;
    margin:0 auto;
    background: #fff;
    padding:20px 20px 50px 20px;
    .list{
        display: flex;
        flex-wrap:wrap;
        padding: 15px 0;
        border-bottom: 1px solid #eeeeee;
        color:#333;
        div{
            margin-right:20px;
            font-weight: bold;
            padding:3px 5px;
        }
        .area{
            width: 1160px;
            font-weight: 500;
            line-height: 35px;
            padding: 0;
        }
        span{
            margin-right:10px;
            cursor: pointer;
            padding:3px 5px;
            border-radius: 2px;
        }
        .active{
            background: red;
            color:#fff;
        }
    }
    .queta-list{
        display: flex;
        flex-wrap:wrap;
        margin:20px 0;
        .main-detail{
            margin-right:20px;
            .mainImg{
                cursor: pointer;
                width: 400px;
                height: 270px;
                border:1px solid #eeeeee;
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    width: 400px;
                    height: auto;
                }
            }
            .intro{
                display: flex;
                justify-content: space-between;
                div{
                    &:nth-of-type(1){
                         line-height: 30px;
                         overflow: hidden;
                         span{
                             margin-right:30px;
                         }
                         div{
                             display: flex;
                             span{
                                 &:nth-of-type(1){
                                    max-width:200px;
                                    white-space:nowrap; 
                                    overflow:hidden; 
                                    text-overflow:ellipsis; 
                                    white-space:nowrap; 
                                 }
                             }
                         }
                    }
                    &:nth-of-type(2){
                        .ant-btn{
                            margin-top:13px;
                        }
                        
                    }
                }
            }
        }
    } 
    .address{
        width: 200px;
        overflow: hidden;
    }
}
</style>